const downloadWebCSV = (webResults, currentIndex) => {
  if (
    !Array.isArray(webResults) ||
    webResults.length === 0 ||
    currentIndex == null ||
    !webResults[currentIndex]
  ) {
    console.error("Invalid web results or index provided.");
    return;
  }

  const scan = webResults[currentIndex];
  const data = scan?.vuln_data || [];
  if (data.length === 0) {
    console.warn("No vulnerability data available for download.");
    return;
  }

  const headers = [
    "Security Alert",
    "Risk Level",
    "Confidence",
    "Analysis",
    "Remediation",
    "URL"
  ];

  const csvRows = data.map(vuln => {
    const securityAlert = vuln.name || vuln.alert || "N/A";
    const riskLevel = vuln.risk || "N/A";
    const confidence = vuln.confidence || "N/A";
    const analysis = (vuln.description || "N/A").replace(/\n/g, ' ');
    const remediation = (vuln.solution || "N/A").replace(/\n/g, ' ');
    const url = vuln.url || "N/A";

    return [
      `"${securityAlert.replace(/"/g, '""')}"`,
      `"${riskLevel.replace(/"/g, '""')}"`,
      `"${confidence.replace(/"/g, '""')}"`,
      `"${analysis.replace(/"/g, '""')}"`,
      `"${remediation.replace(/"/g, '""')}"`,
      `"${url.replace(/"/g, '""')}"`
    ].join(",");
  });

  const csvContent = [
    headers.join(","),
    ...csvRows
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.setAttribute("href", url);
  link.setAttribute("download", `Web_Report_${scan.scan_uuid || "export"}.csv`);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);  
  URL.revokeObjectURL(url); 
};

const downloadNetworkCSV = (networkResults, currentIndex) => {
  console.log('networkResults: ', networkResults);
  if (
    !Array.isArray(networkResults) ||
    networkResults.length === 0 ||
    currentIndex == null
  ) {
    return;
  }

  const scan = networkResults[currentIndex];
  const data = scan?.vuln_data || [];

  if (data.length === 0) return;

  // CSV Headers (match UI)
  const headers = [
    "Vulnerability Title",
    "Severity",
    "Type",
    "Platform",
    "Exploitability",
    "Impact",
    "Codes"
  ];

  const csvRows = data.map(vuln => [
    `"${(vuln.title || "").replace(/"/g, '""')}"`,
    vuln.baseSeverity || "N/A",
    vuln.type || "N/A",
    vuln.platform || "N/A",
    vuln.exploitability || "N/A",
    vuln.impact || "N/A",
    `"${(vuln.codes || "N/A").replace(/"/g, '""')}"`
  ].join(","));

  const csvContent = [
    headers.join(","),
    ...csvRows
  ].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;"
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = `Network_Scan_${scan.scan_uuid || Date.now()}.csv`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadAwsS3CSV = (webResults, currentIndex) => {
  if (
    !Array.isArray(webResults) ||
    webResults.length === 0 ||
    currentIndex == null ||
    !webResults[currentIndex]
  ) {
    console.error("Invalid web results or index provided.");
    return;
  }

  const scan = webResults[currentIndex];
  const data = scan?.vuln_data || [];
  if (data.length === 0) {
    console.warn("No vulnerability data available for download.");
    return;
  }

  const headers = [
    "Security Alert",
    "Risk Level",
    "Confidence",
    "Analysis",
    "Remediation",
    "URL"
  ];

  const csvRows = data.map(vuln => {
    const securityAlert = vuln.name || vuln.alert || "N/A";
    const riskLevel = vuln.risk || "N/A";
    const confidence = vuln.confidence || "N/A";
    const analysis = (vuln.description || "N/A").replace(/\n/g, ' ');
    const remediation = (vuln.solution || "N/A").replace(/\n/g, ' ');
    const url = vuln.url || "N/A";

    return [
      `"${securityAlert.replace(/"/g, '""')}"`,
      `"${riskLevel.replace(/"/g, '""')}"`,
      `"${confidence.replace(/"/g, '""')}"`,
      `"${analysis.replace(/"/g, '""')}"`,
      `"${remediation.replace(/"/g, '""')}"`,
      `"${url.replace(/"/g, '""')}"`
    ].join(",");
  });

  const csvContent = [
    headers.join(","),
    ...csvRows
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.setAttribute("href", url);
  link.setAttribute("download", `Aws_S3_Report_${scan.scan_uuid || "export"}.csv`);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);  
  URL.revokeObjectURL(url); 
};

const downloadAwsEc2CSV = (networkResults, currentIndex) => {
  console.log('networkResults: ', networkResults);
  if (
    !Array.isArray(networkResults) ||
    networkResults.length === 0 ||
    currentIndex == null
  ) {
    return;
  }

  const scan = networkResults[currentIndex];
  const data = scan?.vuln_data || [];

  if (data.length === 0) return;

  // CSV Headers (match UI)
  const headers = [
    "Vulnerability Title",
    "Severity",
    "Type",
    "Platform",
    "Exploitability",
    "Impact",
    "Codes"
  ];

  const csvRows = data.map(vuln => [
    `"${(vuln.title || "").replace(/"/g, '""')}"`,
    vuln.baseSeverity || "N/A",
    vuln.type || "N/A",
    vuln.platform || "N/A",
    vuln.exploitability || "N/A",
    vuln.impact || "N/A",
    `"${(vuln.codes || "N/A").replace(/"/g, '""')}"`
  ].join(","));

  const csvContent = [
    headers.join(","),
    ...csvRows
  ].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;"
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = `Aws_ec2_Scan_${scan.scan_uuid || Date.now()}.csv`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export { 
  downloadWebCSV,
  downloadNetworkCSV,
  downloadAwsS3CSV,
  downloadAwsEc2CSV
};
